import script from "./ResearchGroupList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResearchGroupList.vue?vue&type=script&setup=true&lang=ts"

import "./ResearchGroupList.vue?vue&type=style&index=0&id=1c3d2e0e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c3d2e0e"]])

export default __exports__